export default {
      id: "font-h-usage",
      viewBox: "0 0 512 408.16",
      url: __webpack_public_path__ + "img/svg-sprite.svg#font-h",
      toString: function () {
        return this.url;
      }
    }